import { DollarSign, Clock } from "lucide-react";

export const AdsOfferBanner = () => (
  <section className="bg-primary text-primary-foreground py-6">
    <div className="container mx-auto px-4 flex flex-col md:flex-row items-center justify-center gap-4 md:gap-12 text-center md:text-left">
      <div className="flex items-center gap-3">
        <DollarSign className="w-8 h-8" />
        <div>
          <p className="text-xl font-extrabold">$500 OFF</p>
          <p className="text-sm opacity-90">Complete Roof Replacement</p>
        </div>
      </div>
      <div className="hidden md:block w-px h-12 bg-primary-foreground/30" />
      <div className="flex items-center gap-3">
        <Clock className="w-8 h-8" />
        <div>
          <p className="text-xl font-extrabold">$0 Down</p>
          <p className="text-sm opacity-90">Flexible Financing Available</p>
        </div>
      </div>
    </div>
  </section>
);
